import { dsClass } from '../../common/constants/dsClasses.js';
import { t } from '../../common/i18n/index.js';
import type { JSX } from 'react';

interface InfoElementOnNeutralBackgroundProps {
  child: JSX.Element;
}

const InfoElementOnNeutralBackground = ({ child }: InfoElementOnNeutralBackgroundProps) => (
  <div className="search-info">
    <div className="search-info-text">{child}</div>
  </div>
);

export const SearchTip = () => (
  <InfoElementOnNeutralBackground
    child={
      <p className={dsClass.TEXT_S}>
        {t.SF9W(
          'You can search e.g. by name, phone number, identifier or billing account number. You can search with more than one keyword by separating the words with a space. Type at least two characters.'
        )}
      </p>
    }
  />
);

export interface NoResultsAndSearchTipProps {
  searchTermUsed: string;
}

export const NoResultsAndSearchTip = ({ searchTermUsed }: NoResultsAndSearchTipProps) => {
  return (
    <>
      <div className="no-results">
        {t.O4R1('No results were found for')} <span className={dsClass.FONT_WEIGHT_BOLD}>{searchTermUsed}</span>
        {t.FXKW('.')}
      </div>
      <SearchTip />
    </>
  );
};

export interface TooMuchResultsProps {
  isMultiBiz?: boolean;
}

export const TooMuchResults = ({ isMultiBiz }: TooMuchResultsProps) => (
  <div className="too-much-results">
    <InfoElementOnNeutralBackground
      child={
        <>
          <h5>
            {isMultiBiz
              ? t.L7CX('There are too many search results. Refine your search.')
              : t.HD6M('There are too many search results.')}
          </h5>
          <p className={dsClass.TEXT_S}>
            {isMultiBiz
              ? t.L7DX('You can search with more than one keyword by separating the words with a space.')
              : t.B0MA('Refine your search or view all results through the button below.')}
          </p>
        </>
      }
    />
  </div>
);
